import { render } from "./BusinessClientAccounting.vue?vue&type=template&id=1a4e1e70&scoped=true&ts=true"
import script from "./BusinessClientAccounting.vue?vue&type=script&lang=ts"
export * from "./BusinessClientAccounting.vue?vue&type=script&lang=ts"

import "./BusinessClientAccounting.vue?vue&type=style&index=0&id=1a4e1e70&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e1e70"]])

export default __exports__